import React from 'react';
import DisplayBody from './DisplayBody';

const DisplaySurvey = (props) => {
  const { actionsBtn, survey_code } = props;
  return <DisplayBody actionsBtn={actionsBtn} survey_code={survey_code} />;
};

export default DisplaySurvey;
